import api from "@/api/api-v2-config";
import baseapi from "@/api/api-v1-config";

//#region Service Template

export async function getServiceTemplatesListAxios() {    
    return await api.get("serviceorders/getserviceordertemplatebycriteria");
}

export async function getStaffForTemplatesListAxios() {    
    return await api.get("serviceorders/staffforserviceordertemplate");
}

export async function getServiceTemplateByIDAxios(id) {    
    return await api.get("serviceorders/getordertemplatebyid?Id=" + id);
}

export async function getServiceTemplateByReferenceNoAxios(id) {    
    return await api.get("serviceorders/getserviceorderbyreferenceno?referenceNo=" + id);
}

export async function postServiceTemplateAxios(servicerequests) {    
    return await api.post("serviceorders/ordertemplate", servicerequests);
}

export async function putServiceTemplateAxios(servicerequests) {  
    return await api.put("serviceorders/ordertemplate", servicerequests);
}

export async function deleteServiceTemplateAxios(id) {    
    return await api.delete("serviceorders/ordertemplate?id="+id);
}

export async function postServiceTemplateDocumentAxios(servicerequests) {    
    return await api.post("serviceorders/servicetemplatedocument", servicerequests);
}

export async function putServiceTemplateDocumentAxios(servicerequests) {    
    return await api.put("serviceorders/servicetemplatedocument", servicerequests);
}

// export async function uploadTemplateDocumentAxios(payload) {
//     console.log("payload", payload);
//     const formData = new FormData();
//     formData.append('ServiceTemplateId', payload.ServiceTemplateId);
//     formData.append('File', payload.file);
//     api.defaults.headers["Content-Type"] = "multipart/form-data";
//     console.log("formdata", formData);
//     return await api.post('serviceorders/servicetemplatedocument', formData);
// }

export async function getServiceTemplateDocumentsAxios(id) {    
    return await api.get("serviceorders/getservicetemplatedocuments?OrderTemplateId="+id);
}

export async function getServiceTemplateDocumentAxios(serviceTemplateId, DocId) {    
    return await api.get("serviceorders/getservicetemplatedocument?ServiceTemplateId="+serviceTemplateId+"&ServiceTemplateDocId="+DocId);
}

//#endregion

//#region Service Order

export async function getServiceOrderListAxios(status = null) {    
    let url = "serviceorders/getserviceorderbycriteria";
    if(status != null) url  += `?serviceOrderStatus=${status}`;
    return await api.get(url);
}

export async function getServiceOrderByIDAxios(id) {    
    return await api.get("serviceorders/getserviceorderbyid?Id=" + id);
}

export async function postServiceOrderAxios(servicerequests) {    
    return await api.post("serviceorders/serviceorder", servicerequests);
}

export async function putServiceOrderAxios(servicerequests) {    
    return await api.put("serviceorders/serviceorder", servicerequests);
}

export async function postServiceOrderSignatureAxios(servicerequests) {    
    return await api.post("serviceorders/signature", servicerequests);
}

export async function getServiceOrderSignatureByIdAxios(id) {    
    return await api.get("serviceorders/getsignature?Id=" + id);
}

export async function postServiceOrderDocumentAxios(servicerequests) {    
    return await api.post("serviceorders/document", servicerequests);
}

export async function putServiceOrderDocumentAxios(servicerequests) {    
    return await api.put("serviceorders/document", servicerequests);
}

export async function removeServiceOrderDocumentAxios(referenceId) {
    return await api.delete("serviceorders/servicedocument", { data: { referenceId } });
  }

export async function getServiceOrderDocumentsAxios(id) {    
    return await api.get("serviceorders/getdocuments?ServiceOrderId="+id);
}

export async function getServiceOrderDocumentAxios(serviceOrderId, DocId) {    
    return await api.get("serviceorders/getdocument?ServiceOrderId="+serviceOrderId+"&ServiceOrderDocId="+DocId);
}

export async function putServiceOrderApproveOrCancelAxios(servicerequests) {    
    return await api.put("serviceorders/approveorcancel", servicerequests);
}

export async function putServiceOrderRescheduleAxios(servicerequests) {    
    return await api.put("serviceorders/reschedule", servicerequests);
}

//#endregion

//#region Timesheet

export async function getServiceTimesheetListAxios(modulereference) {    
    let url = "tenants/ServiceOrder/timesheet?pageSize=10000&skip=1";
    if(modulereference) url += `&moduleReference=${modulereference}`
    return await baseapi.get(url);
}

export async function getServiceTimesheetByIDAxios(modulereference,id) {    
    return await baseapi.get(`tenants/${modulereference}/timesheetbyid?ID=` + id);
}

export async function postServiceTimesheetAxios(servicerequests) {    
    return await baseapi.post(`tenants/ServiceOrder/submittimesheet`, servicerequests);
}

export async function putServiceTimesheetAxios(servicerequests) {    
    return await baseapi.put(`tenants/ServiceOrder/updatetimesheet`, servicerequests);
}

//#endregion


export async function putApproveOrCancelAxios(servicerequests) {    
    return await api.put("serviceorders/approveorcancel", servicerequests);
}

export async function putRescheduleAxios(servicerequests) {    
    return await api.put("serviceorders/reschedule", servicerequests);
}

export async function postImportTimesheetAxios(payload) {    
    return await api.post("uploads/importtimesheets", payload);
}


